module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1a.6b561ab1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1a.svg
// module id = 509
// module chunks = 0